import { PerkCardTemplate, PerkCardTemplateProps } from "./template";

export type PerkCardProps = PerkCardTemplateProps;

export const PerkCard = (props: PerkCardProps): JSX.Element => {
  return <PerkCardTemplate {...props} />;
};
